export const LOCATION_TYPE_IDS = {
	'truck-terminal' : 'truck-terminal',
};